export class NgxGalleryAnimation {
  static Fade = "fade";
  static Slide = "slide";
  static Rotate = "rotate";
  static Zoom = "zoom";
}



// WEBPACK FOOTER //
// /agir/src/app/components/ngx-gallery/ngx-gallery-animation.model.ts